/**
 * Border Radius Design Tokens
 *
 * Standard border radius values for consistent rounded corners
 * across all components.
 */

export const radius = Object.freeze({
  none: '0px',
  xxs: '2px', // Hairline - tight card corners, dense grids
  xsm: '4px', // Extra small - badges, small chips
  sm: '6px', // Small - buttons, inputs, small cards
  med: '12px', // Medium - cards, dialogs
  lg: '16px', // Large - prominent cards, modals
  xl: '24px', // Extra large - hero sections, large surfaces
  full: '9999px', // Pill shapes, circles
})
